import { no_propagate } from "./utils";

// The voyagers on the currently selected trip. Only reachable while a trip is
// selected, so the button that opens it is hidden the rest of the time.
const MenuTrip = ({ active, trips, selected_trip, set_selected_person, close_menu }) => {

  if (selected_trip === null) return null;

  const trip = trips[selected_trip];

  const select_person = (person_index) => {
    close_menu();
    set_selected_person(person_index);
  };

  return (
    <div className={"menu_panel" + (active ? "" : " menu_panel_hidden")}
         onClick={close_menu}>
      <label className="info_label">{trip.trip_key_memory}'s Voyagers</label>
      <ul className="info_button_list">
        {trip.person_trips.map((person_trip) => (
          <li className="info_button" key={person_trip.person_index}
              onClick={no_propagate(() => select_person(person_trip.person_index))}>
            {person_trip.person.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MenuTrip;
